import { InjectionToken } from '@angular/core';

export const LOCAL_STORAGE = new InjectionToken<Storage>('Global localStorage object', {
  factory: () => localStorage
});
